<template>
  <div v-show="title" :class="['alert', notificationClasses, {'in': isOpen}, {'alert-dismissable': dismissable}, alertClass]" :style="alertStyles">
    <button v-if="dismissable" type="button" class="close" data-dismiss="alert" aria-label="Close" v-on:click="emitDismiss"><span aria-hidden="true">×</span></button>
    <strong>
      <i v-if="icon" :class="[iconPrefix, iconClass]"></i>
      {{ title }}
    </strong>
    <slot v-if="text">{{ text }}</slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    },
    color:  {
      type: String,
      default: 'danger'
    },
    icon:  {
      type: String,
      default: 'exclamation-triangle'
    },
    iconPrefix: {
      type: String,
      default: 'fa'
    },
    dismissable: {
      type: Boolean,
      default: false
    },
    notification: {
      type: String,
      default: ''
    },
    isHidden: {
      type: Boolean,
      default: true
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    notificationClasses() {
      var parts = this.notification.split(' ');
      if (parts.length == 2) {
        return 'alert-notification alert-' + parts[0] + ' alert-' + parts[1];
      }
    },
    alertClass() {
      switch (this.color) {
        case 'success':
        case 'info':
        case 'warning':
          return 'alert-' + this.color;
          break;
        default:
          return 'alert-danger';
      }
    },
    alertStyles() {
      if (!this.isHidden) {
        return {
          display: 'block',
          'padding-right': '15px'
        };
      }

      return {
        display: 'none'
      };
    },
    iconClass() {
      return 'fa-' + this.icon;
    }
  },
  methods: {
    emitDismiss() {
      this.$emit('dismiss');
    },
    toggle(ref) {
      if (ref.isOpen) {
        this.close(ref);
      } else {
        this.open(ref);
      }
    },
    open(ref, timeout) {
      this.$emit('open');

      ref.isHidden = false;
      setTimeout(function() {
        ref.isOpen = true;
      }, 200);

      if (typeof timeout == 'number') {
        setTimeout(function() {
          this.close(ref);
        }.bind(this), timeout);
      }

    },
    close(ref) {
      this.$emit('close');

      ref.isOpen = false;
      setTimeout(function(){
        ref.isHidden = true;
      }, 200);
    }
  }
}

</script>
